


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { RouteNames } from '@/utils/router/router.models';
import SimpleRoundedLoader from '../../../../components/utils/SimpleRoundedLoader/index.vue';
import { namespace } from 'vuex-class';

const configurationModule = namespace('configuration');

@Component({
  components: {
    SimpleRoundedLoader
  }
})
export default class SummaryInfo extends Vue {
  @Prop({}) headline!: string;
  @Prop({}) description!: string;
  @Prop({}) navName!: string;
  @Prop({}) navLabel!: string;
  @Prop({ default: true }) renderActions!: boolean;
  @Prop({ default: false }) showOverscroll!: boolean;
  @Prop({ default: false }) invertScrollControl!: boolean;

  @configurationModule.Action private getBAB!: () => string;

  private RouteNames: typeof RouteNames = RouteNames;

  private pdfLoading = false;

  private async openPDF(event: Event) {
    event.preventDefault();

    this.pdfLoading = true;

    const PDFUrl: string = await this.getBAB();

    this.$gtm.trackConfigurationPrint();

    this.pdfLoading = false;

    if (PDFUrl) {
      const a = document.createElement('a');

      a.style.display = 'none';
      // this breaks iOS Safari and I don't know why or how to fix it.
      a.target = '_blank';
      a.href = PDFUrl;

      document.body.appendChild(a);
      a.click();

      // Firefox hack with setTimeout
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(PDFUrl);
      }, 100);
    }
  }

  @Emit()
  public scroll() {
    return null;
  }
}
